import { createSlice } from "@reduxjs/toolkit";


const initState = {
    phone:'',
    predictiontype: '',
    matchId: '',
    startTime: '',
    endTime: ''
}

export const predictInfo = createSlice({
    name:'PredictInfo',
    initialState:initState,
    reducers:{
        getFormData:(state,action)=>{
            state[action.payload.name] = action.payload.value
        },
    },

})

export const { getFormData } =predictInfo.actions

export default predictInfo.reducer